import { useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@mui/material';
import { usePageTitle, useRouterOutlet } from '../../hooks';
import { Container, FilterBar } from '../../components';
import { getPageTitle } from '../../utils/pages';
import { UserPermission } from '../../enums';
import { RequirePermission } from '../../security';
import { CorporateCompaniesTable } from '../../components/CorporateCompaniesTable/CorporateCompaniesTable.component';
import { Company } from '../../models';
import { CompaniesPartial } from './partials';

const CorporateCompanies: React.FC = () => {
  const { t } = useTranslation();
  const { showOutletOnly } = useRouterOutlet();
  const navigate = useNavigate();
  const params = useParams();
  const showTabs = Object.keys(params).length === 0;

  usePageTitle(getPageTitle('companies'));

  const [name, setName] = useState('');

  const filterButtons = (
    <Button
      variant="contained"
      onClick={() => navigate('/admin/corporate-companies/new')}
    >
      {t('corporateCompanies.actions.add')}
    </Button>
  );

  return (
    <RequirePermission oneOf={[UserPermission.ManageCorporateCompanies]}>
      <CompaniesPartial showTabs={showTabs}>
        {showOutletOnly || (
          <>
            <FilterBar
              title={t('corporateCompanies.filterCorporateCompanies')}
              buttons={filterButtons}
            >
              <TextField
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
                label={t('companies.fields.companyName')}
              />
            </FilterBar>

            <Container>
              <CorporateCompaniesTable
                name={name}
                onDeleteClick={(company: Company) =>
                  navigate(`/admin/corporate-companies/${company.id}/delete`)
                }
              />
            </Container>
          </>
        )}
        <Outlet />
      </CompaniesPartial>
    </RequirePermission>
  );
};

export default CorporateCompanies;
